module.exports = __webpack_public_path__ + "img/tips_bg_green.060dd05b.png";